import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatTabGroup } from '@angular/material';
import { FuseConfigService } from '@fuse/services/config.service';
import { AddLocationComponent } from 'app/shared/common/add-location/add-location.component';
import { AddOrganizationComponent } from 'app/shared/common/add-organization/add-organization.component';
import { AddRoleComponent } from 'app/shared/common/add-role/add-role.component';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import axios from 'axios';
import { ToastrService } from 'ngx-toastr';
import { ProfileCropComponent } from '../profile/tabs/profile-crop/profile-crop.component';
export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})


export class SettingsComponent implements OnInit {

  organizationDetailsForm: FormGroup;
  proImage: any;
  imageURL = 'assets/images/avatars/profile.jpg';
  profileCropDialogRef: MatDialogRef<ProfileCropComponent>;
  apiUrl: any;
  organizationId = '';
  tenantId = '';
  empRole = '';
  locationList = [];
  locationCount = 0;
  departmentList = [];
  departmentCount = 0;
  roleList = [];
  roleCount = 0;
  organizationList = [];
  organizationCount = 0;
  locationCols = [
    { field: 'position', header: 'Position' },
    { field: 'location', header: 'Location' },
    { field: 'createdBy', header: 'Created By' },
    { field: 'organisation', header: 'Organization' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Action' }
  ];
  departmentCols = [
    { field: 'position', header: 'Position' },
    { field: 'department', header: 'Department' },
    { field: 'createdBy', header: 'Created By' },
    { field: 'organisation', header: 'Organization' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Action' }
  ];
  roleCols = [
    { field: 'position', header: 'Position' },
    { field: 'role', header: 'Role' },
    { field: 'createdBy', header: 'Created By' },
    { field: 'organisation', header: 'Organization' },
    { field: 'status', header: 'Status' },
    // { field: 'actions', header: 'Action' }
  ];
  organizationCols = [
    { field: 'position', header: 'Position' },
    { field: 'organization', header: 'Organization' },
    { field: 'createdBy', header: 'Created By' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Action' }
  ];
  settings = true;
  selectedStep = 0;
  windowsLink = '';
  linuxLink = '';
  macLink = '';
  androidLink = '';

  profileId = '';
  @ViewChild(MatTabGroup, { static: false }) tabGroup: MatTabGroup;
  organisationLists = [];
  industryId: any;

  constructor(
    private parseService: ParseService,
    private formBuilder: FormBuilder,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private getReportingToService: GetReportingToService,
    private _fuseConfigService: FuseConfigService,
  ) {
            // Configure the layout
            this._fuseConfigService.config = {
              layout: {
                navbar: {
                  hidden: false
                },
                toolbar: {
                  hidden: false
                },
                footer: {
                  hidden: false
                },
                sidepanel: {
                  hidden: false
                }
              }
            };
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.organizationDetailsForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required]
    });
  }

  async ngOnInit() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(settings => {
      this.apiUrl = settings[0].get('apiUrl');
      let buildLinks = settings[0].get('buildLinks');
      if (buildLinks != undefined) {
        let windows = buildLinks.filter(x => x.name == 'Windows');
        let linux = buildLinks.filter(x => x.name == 'Linux');
        let mac = buildLinks.filter(x => x.name == 'Mac');
        let android = buildLinks.filter(x => x.name == 'Android');
        this.windowsLink = windows[0].url;
        this.linuxLink = linux[0].url;
        this.macLink = mac[0].url;
        this.androidLink = android[0].url;
      }
    });
    this.getOrganizationDetails();
    this.getOrganizationList();
    this.getOrganisation();
  }

  async getOrganizationDetails() {
    let organizationClass = this.parseService.instance.Object.extend('Organization');
    let query = new this.parseService.instance.Query(organizationClass);
    let res = await query.find();
    if (res.length > 0) {
      let results = res[0];
      this.organizationDetailsForm.patchValue({
        name: results.get('name'),
        email: results.get('email'),
        mobile: results.get('data').mobile
      });
      this.proImage = results.get('organizationLogo');
    }
  }

  imageUpload() {
    this.profileCropDialogRef = this.dialog.open(ProfileCropComponent, {
      width: '700px',
    });
    this.profileCropDialogRef.afterClosed().subscribe(result => {
      if (result.status) {
        this.logoUpload(result.file);
      }
    });
  }

  logoUpload(event) {
    var formData = new FormData();
    formData.append("files", event);
    var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
    axios.post(this.apiUrl.mediaPath, formData, {
      headers: {
        "authorization": "Bearer " + session,
        'Content-Type': "application/x-www-form-urlencoded"
      }
    }).then(res => {
      this.profileUpdate(res);
    }).catch(err => {
    });
  }

  async profileUpdate(data) {
    let organizationClass = this.parseService.instance.Object.extend('Organization');
    let query = new this.parseService.instance.Query(organizationClass);
    let value = await query.find();
    var result = value[0];
    result.set('organizationLogo', data.data.url);
    let res = await result.save();
    this.getOrganizationDetails();
    this.toastr.success('Profile uploaded successfully');
  }

  async getLocationList() {
    const locationInstance = this.parseService.instance.Object.extend('Location');
    const locationQuery = new this.parseService.instance.Query(locationInstance);
    locationQuery.include('createdBy');
    locationQuery.equalTo('tenantId', this.tenantId);
    const locationResults = await locationQuery.find();
    this.locationList = [];
    if (locationResults.length > 0) {
      let i = 0;
      for (const element of locationResults) {
        i = i + 1;
        this.locationList.push({
          position: i,
          id: element.id,
          location: element.get('name'),
          createdBy: element.get('createdBy') ? element.get('createdBy').get('firstName') + ' ' + element.get('createdBy').get('lastName') : '',
          createdByProfile: element.get('createdBy') ? element.get('createdBy').get('profileImageInfo').url : '',
          status: element.get('isActive')
        });
      }
    }
    this.locationCount = this.locationList.length;
  }

  openLocationDialog() {
    const dialogRef = this.dialog.open(AddLocationComponent, {
      width: '500px',
      data: { isEdit: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLocationList();
    });
  }

  editLocation(id) {
    const dialogRef = this.dialog.open(AddLocationComponent, {
      width: '500px',
      data: { id: id, isEdit: true }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLocationList();
    });
  }

  async changeLocationStatus(id, event) {
    const locationInstance = this.parseService.instance.Object.extend('Location');
    const locationQuery = new this.parseService.instance.Query(locationInstance);
    locationQuery.equalTo('objectId', id);
    const locationResults = await locationQuery.find();
    let result = locationResults[0];
    result.set('isActive', event.checked);
    let value = await result.save();
    this.toastr.success('Updated successfully.');
  }

  // async deleteLocation(id) {
  //   const locationInstance = this.parseService.instance.Object.extend('Location');
  //   const locationQuery = new this.parseService.instance.Query(locationInstance);
  //   locationQuery.equalTo('objectId', id);
  //   const locationResults = await locationQuery.find();
  //   let result = locationResults[0];
  //   let data = await result.destroy();
  //   this.getLocationList();
  //   this.toastr.success('Location deleted successfully');
  // }

  tabChange(event) {
    switch (event.index) {
      case 0:
        // this.getOrganizationList();
        break;
      case 1:
        this.getOrganizationList();
        break;
      case 2:
        this.getLocationList();
        break;
      case 3:
        this.getDepartmentList();
        break;
      case 4:
        this.getRoleList();
        break;
    }
  }

  async getDepartmentList() {
    const departmentInstance = this.parseService.instance.Object.extend('Department');
    const departmentQuery = new this.parseService.instance.Query(departmentInstance);
    departmentQuery.include('createdBy');
    departmentQuery.equalTo('tenantId', this.tenantId);
    const departmentResults = await departmentQuery.find();
    this.departmentList = [];
    if (departmentResults.length > 0) {
      let i = 0;
      for (const element of departmentResults) {
        i = i + 1;
        this.departmentList.push({
          position: i,
          id: element.id,
          department: element.get('name'),
          createdBy:  element.get('createdBy') ? element.get('createdBy').get('firstName')+ ' ' + element.get('createdBy').get('lastName') : '',
          createdByProfile:element.get('createdBy') ? element.get('createdBy').get('profileImageInfo').url : '',
          status: element.get('isActive')
        });
      }
    }
    this.departmentCount = this.departmentList.length;
  }

  openDepartmentDialog() {
    // const dialogRef = this.dialog.open(AddDepartmentComponent, {
    //   width: '500px',
    //   data: { isEdit: false }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   this.getDepartmentList();
    // });
  }

  editDepartment(id) {
    // const dialogRef = this.dialog.open(AddDepartmentComponent, {
    //   width: '500px',
    //   data: { id: id, isEdit: true }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   this.getDepartmentList();
    // });
  }

  async changeDepartmentStatus(id, event) {
    const departmentInstance = this.parseService.instance.Object.extend('Department');
    const departmentQuery = new this.parseService.instance.Query(departmentInstance);
    departmentQuery.equalTo('objectId', id);
    departmentQuery.equalTo('industry', { __type: 'Pointer', className: 'Industry', objectId: this.industryId });
    const departmentResults = await departmentQuery.find();
    let result = departmentResults[0];
    result.set('isActive', event.checked);
    let value = await result.save();
    this.toastr.success('Updated successfully.');
  }

  async getRoleList() {
    const roleInstance = this.parseService.instance.Object.extend('_Role');
    const roleQuery = new this.parseService.instance.Query(roleInstance);
    roleQuery.include('createdBy');
    const roleResults = await roleQuery.find();
    this.roleList = [];
    if (roleResults.length > 0) {
      let i = 0;
      for (const element of roleResults) {
        i = i + 1;
        this.roleList.push({
          position: i,
          id: element.id,
          role: element.get('name'),
          createdBy: element.get('createdBy').get('firstName') + ' ' + element.get('createdBy').get('lastName'),
          createdByProfile: element.get('createdBy').get('profileImageInfo').url,
          status: element.get('isActive')
        });
      }
    }
    this.roleCount = this.roleList.length;
  }

  openRoleDialog() {
    const dialogRef = this.dialog.open(AddRoleComponent, {
      width: '500px',
      data: { isEdit: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getRoleList();
    });
  }

  editRole(id) {
    const dialogRef = this.dialog.open(AddRoleComponent, {
      width: '500px',
      data: { id: id, isEdit: true }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getRoleList();
    });
  }

  async changeRoleStatus(id, event) {
    const roleInstance = this.parseService.instance.Object.extend('_Role');
    const roleQuery = new this.parseService.instance.Query(roleInstance);
    roleQuery.equalTo('objectId', id);
    const roleResults = await roleQuery.find();
    let result = roleResults[0];
    result.set('isActive', event.checked);
    let value = await result.save();
    this.toastr.success('Updated successfully.');
  }


  async getOrganizationList() {
    const organizationInstance = this.parseService.instance.Object.extend('Organisation');
    const organizationQuery = new this.parseService.instance.Query(organizationInstance);
    // organizationQuery.include('createdBy');
    organizationQuery.equalTo('tenantId', this.tenantId);
    const organizationResults = await organizationQuery.find();
    this.organizationList = [];
    if (organizationResults.length > 0) {
      let i = 0;
      for (const element of organizationResults) {
        i = i + 1;
        this.organizationList.push({
          position: i,
          id: element.id,
          organization: element.get('name'),
          createdBy: element.get('createdBy') ? element.get('createdBy').get('firstName') ? element.get('createdBy').get('firstName') : '' 
          + ' ' + element.get('createdBy').get('lastName') ? element.get('createdBy').get('lastName') : '' : '',   
          // createdBy: element.get('createdBy') ? element.get('createdBy').get('firstName') + ' ' + element.get('createdBy').get('lastName') : '',   
          createdByProfile: element.get('createdBy') ? element.get('createdBy').get('profileImageInfo') ? element.get('createdBy').get('profileImageInfo').url : '' : '',
          status: element.get('isActive')
        });
      }
    }
    this.organizationCount = this.organizationList.length;
  }

  openOrganizationDialog() {
    const dialogRef = this.dialog.open(AddOrganizationComponent, {
      width: '500px',
      data: { isEdit: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getOrganizationList();
    });
  }

  editOrganization(id) {
    const dialogRef = this.dialog.open(AddOrganizationComponent, {
      width: '500px',
      data: { id: id, isEdit: true }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getOrganizationList();
    });
  }

  async changeOrganizationStatus(id, event) {
    const organizationInstance = this.parseService.instance.Object.extend('Organisation');
    const organizationQuery = new this.parseService.instance.Query(organizationInstance);
    organizationQuery.equalTo('objectId', id);
    const organizationResults = await organizationQuery.find();
    let result = organizationResults[0];
    result.set('isActive', event.checked);
    let value = await result.save();
    this.toastr.success('Updated successfully.');
  }

  async getOrganisation() {
    await this.getReportingToService.getOrganisation().then(res => {
      this.organisationLists = res;
    });
  }

}

